export default __webpack_public_path__ + "static/media/logo.97664209.png";